import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mr-2 btn-text" }

import { useI18n } from "vue-i18n";



export default /*@__PURE__*/_defineComponent({
  __name: 'CloseButton',
  emits: ["clicked"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "flex h-14 items-center group",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('clicked')))
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)("buttons.close")), 1),
    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "flex items-center justify-center size-[42px] xl:size-14 rounded-full icon" }, [
      _createElementVNode("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("path", {
          d: "M1 1L15 15M15 1L1 15",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ])
    ], -1))
  ]))
}
}

})